(function(){
  'use strict';
  var MIN_DAYS = 6, MAX_DAYS = 9;
  function today(){
    try {
      var o = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function(p){ o[p.type] = p.value; });
      return new Date(+o.year, +o.month - 1, +o.day, 12);
    } catch (e) { var d = new Date(); return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12); }
  }
  function plus(d, n){ var r = new Date(d.getTime()); r.setDate(r.getDate() + n); if (r.getDay() === 0) r.setDate(r.getDate() + 1); return r; }
  function fmt(d){ return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' }); }
  function range(){ var t = today(); return fmt(plus(t, MIN_DAYS)) + ' – ' + fmt(plus(t, MAX_DAYS)); }
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>';
  function css(){
    if (document.getElementById('tt-eta-css')) return;
    var s = document.createElement('style'); s.id = 'tt-eta-css';
    s.textContent = '.tt-eta{display:flex;align-items:center;gap:10px;margin:12px 0 4px;padding:11px 14px;border:2px solid #13203B;border-radius:14px;background:#FFF7E8;box-shadow:3px 3px 0 #13203B;color:#13203B;font-size:14px;line-height:1.35}.tt-eta svg{flex:0 0 22px;width:22px;height:22px;color:#FF6B1A}.tt-eta strong{font-family:Unbounded,sans-serif;font-weight:700}.tt-eta small{display:block;opacity:.7;font-size:12px}';
    document.head.appendChild(s);
  }
  function run(root){
    root = root || document;
    var r = range();
    root.querySelectorAll('strong').forEach(function(el){
      if (/^Order today, get it in/i.test(el.textContent.trim())) { el.textContent = 'Order today, get it ' + r + '.'; }
    });
    root.querySelectorAll('.mm-buy').forEach(function(b){
      if (b.nextElementSibling && b.nextElementSibling.classList.contains('tt-eta')) return;
      css();
      var d = document.createElement('div'); d.className = 'tt-eta';
      d.innerHTML = TRUCK + '<div>Order today, get it <strong>' + r + '</strong><small>Estimated delivery · tracked</small></div>';
      b.parentNode.insertBefore(d, b.nextSibling);
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ run(); }); } else { run(); }
  document.addEventListener('shopify:section:load', function(e){ run(e.target); });
})();
